module.exports = __webpack_public_path__ + "media/images/blog/post-9ff9aca12cc424dcde091e82373d1f1a.png";